import { app } from '../app';

app.factory('BarcodeGeneratonService', BarcodeGeneratonService);

/** @ngInject */
function BarcodeGeneratonService($resource) {
    return $resource('app/rest/barcode/:uuid', {}, {
        "applicationBarcode" : {
            method : 'GET',
            url : 'app/rest/barcode/:uuid?appKey=:appKey',
            params : {
                uuid : '@uuid',
                appKey : '@appKey'
            }
        },
        "simulatorBarcode" : {
            method : 'GET',
            url : 'app/rest/barcode/simulator/:uuid?appKey=:appKey',
            params : {
                uuid : '@uuid',
                appKey : '@appKey'
            }
        },
        "onpremDeviceActivator" : {
        	method: 'GET',
        	url : 'app/rest/company/:companyId/generateOnpremActivationBarcode',
        	params:{companyId: '@companyId'}
        	
        }
    });
}



// WEBPACK FOOTER //
// ./src/portal/services/barcode-generation.service.js